import { chartNoteClinicalQualityScoresOptions } from '@cartwheel/api/v1'
import { Modal, Spinner } from '@cartwheel/components'
import { useQuery } from '@tanstack/react-query'
import { ClinicalQualityScoreHistory } from './clinical-quality-score-history'

interface Props {
  isOpen: boolean
  onClose: () => void
  chartNoteId: string
  clientId: string
}

export function ClinicalQualityScoreHistoryModal({
  isOpen,
  onClose,
  chartNoteId,
  clientId,
}: Props) {
  const { data, isPending, isError } = useQuery({
    ...chartNoteClinicalQualityScoresOptions({
      path: { chart_note_id: chartNoteId },
      query: { client_id: clientId },
    }),
    enabled: isOpen,
  })

  const scores = data?.clinical_quality_scores ?? []

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Score history">
      {isPending ? (
        <div className="flex items-center justify-center py-8">
          <Spinner size="sm" />
        </div>
      ) : isError ? (
        <p className="text-sm text-orange py-4">Unable to load score history. Please try again.</p>
      ) : scores.length === 0 ? (
        <p className="text-sm text-charcoal-50 py-4">No scores yet for this note.</p>
      ) : (
        <ClinicalQualityScoreHistory scores={scores} />
      )}
    </Modal>
  )
}
